import loadable from "@loadable/component";
import { inject, observer } from "mobx-react";
import { Fragment } from "react";

import { SiteThemeProps } from "@inferno/renderer-shared-core";
import { AppTray } from "../../core/chrome/AppTray.component";
import { Routes } from "../Routes";
import { TemplateComponent } from "../TemplateComponent.component";
import { Footer } from "./chrome/Footer.component";
import { Header } from "./chrome/Header.component";
import PremierePushdownAd from "./chrome/PremierePushdownAd.component";
import "./index.style.scss";

const LegalNoticeLoader = loadable(() => import("../../core/page-blocks/legalnotice/LegalNoticeLoader.component"), {
  ssr: false,
});
const LeavingSiteLoader = loadable(() => import("../../core/components/leaving-site/LeavingSiteLoader.component"), {
  ssr: false,
});
const IHRPlayerBar = loadable(() => import("../../core/chrome/IHRPlayerBar.component"), {
  ssr: false,
});

export const PremiereSiteTheme = inject("store")(
  observer(({ store, siteTheme }: SiteThemeProps) => {
    if (!store) {
      return null;
    }

    const { request } = store;
    const inApp = !!request.query?.inapp;

    return (
      <TemplateComponent display="grid">
        <Routes
          siteTheme={siteTheme}
          headerGroup={
            <Fragment>
              <PremierePushdownAd />
              {!inApp ? <Header /> : null}
            </Fragment>
          }
          footerGroup={
            <Fragment>
              <LeavingSiteLoader />
              <Footer />
              <AppTray />
              <LegalNoticeLoader />
            </Fragment>
          }
        />
        {!inApp ? <IHRPlayerBar /> : null}
      </TemplateComponent>
    );
  }),
);

export default PremiereSiteTheme;
